/**
 * @flow
 * @relayHash 93794244ab43e69ea15458d555b720ea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IntegrationOriginRule = "SOURCE_TO_WC" | "TWO_WAY" | "WC_TO_SOURCE";
export type AddIntegrationEventInput = {|
  integrationId: string,
  eventTypeId: string,
  originRule: IntegrationOriginRule,
  lambdaId?: ?string,
  lambdaOnly?: ?boolean,
|};
export type AddIntegrationEventMutationVariables = {|
  input: AddIntegrationEventInput
|};
export type AddIntegrationEventMutationResponse = {|
  +addIntegrationEvent: {|
    +integrationEventEdge: {|
      +node: {|
        +id: string,
        +originRule: IntegrationOriginRule,
        +lambdaOnly: boolean,
        +lambdaId: ?string,
        +eventType: {|
          +id: string,
          +name: string,
          +cosmeticName: string,
        |},
      |}
    |}
  |}
|};
export type AddIntegrationEventMutation = {|
  variables: AddIntegrationEventMutationVariables,
  response: AddIntegrationEventMutationResponse,
|};
*/


/*
mutation AddIntegrationEventMutation(
  $input: AddIntegrationEventInput!
) {
  addIntegrationEvent(input: $input) {
    integrationEventEdge {
      node {
        id
        originRule
        lambdaOnly
        lambdaId
        eventType {
          id
          name
          cosmeticName
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddIntegrationEventInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addIntegrationEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddIntegrationEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "integrationEventEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "IntegrationEventEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "IntegrationEvent",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "originRule",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lambdaOnly",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lambdaId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "eventType",
                "storageKey": null,
                "args": null,
                "concreteType": "EventType",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cosmeticName",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddIntegrationEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddIntegrationEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddIntegrationEventMutation",
    "id": null,
    "text": "mutation AddIntegrationEventMutation(\n  $input: AddIntegrationEventInput!\n) {\n  addIntegrationEvent(input: $input) {\n    integrationEventEdge {\n      node {\n        id\n        originRule\n        lambdaOnly\n        lambdaId\n        eventType {\n          id\n          name\n          cosmeticName\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12b984cf46b539f6a35ada0db7b765da';
module.exports = node;
